import React  from 'react';
import { BgisDetailsSplitter } from './BgisDetailsSplitter';
import { BgisHideDetail } from './BgisHideDetails';
export type BgisDetailProps = {
  children?: React.ReactNode;
};

export const BgisDetails: React.FC<BgisDetailProps> = ({ children }) => {
  return (
    <section className='bgis-details bgis-toggled-overlayable'>
      <BgisDetailsSplitter></BgisDetailsSplitter>
      {children}
      <BgisHideDetail></BgisHideDetail>
    </section> 
  );

};
